module.exports = new __parcel__URL__("battle_pass_icon_v2.162c23c1.png").toString();